"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enL18n = void 0;
exports.enL18n = {
    write: "Write",
    preview: "Preview",
    uploadingImage: "Uploading image...",
    pasteDropSelect: "Attach files by dragging & dropping, selecting or pasting them."
};
